var $ = require('./../sw-jquery/sw-jquery');
var sw = require('./sw');
var _ = require('underscore');

$(function() {

  var merchantFormId = sw.data.braintreeMerchantForm;

  if (!_.isArray(merchantFormId)) {
    merchantFormId = [merchantFormId];
  }

  // Anti fraud
  var $btAntiFraudForms = $(_.map(merchantFormId, function(item) {
    return '#' + item;
  }).join(','));

  if ($btAntiFraudForms.length && sw.data.braintreeMerchantId) {

    window.onBraintreeDataLoad = function() {
      _.each(merchantFormId, function(mfid) {
        window.BraintreeData.setup(sw.data.braintreeMerchantId, mfid, window.BraintreeData.environments.production);
      });
    };

    var script = document.createElement('script');
    script.src = '//js.braintreegateway.com/v1/braintree-data.js';
    script.async = !0;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

});